module.exports = __webpack_public_path__ + "static/media/taylor-swift.711a2715.jpg";